/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// DEFINITION OF THE GLOBAL EVENT BUS /////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

globalThis.SiteApp = globalThis.SiteApp || {};

globalThis.SiteApp.eventBus = {

// on method registers a custom event "eventName" listener only for the document element (because the "document" element knows all the DOM elem. it contains
// eventHandler performs some specific operations on some specific DOM elements of the document
	on(eventName, eventHandler) {
		document.addEventListener(eventName, (e) => {
			eventHandler(e.detail); })
		},

// emit method dispatches (sends) a custom event "eventName" on the document if the emitting block exists 		
		emit(eventName, detail = {}) {
			document.dispatchEvent(new CustomEvent(eventName, { detail }));
		},
	};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////